var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 10.0003C1.66797 6.07195 1.66797 4.10777 2.88836 2.88738C4.10875 1.66699 6.07293 1.66699 10.0013 1.66699C13.9297 1.66699 15.8939 1.66699 17.1142 2.88738C18.3346 4.10777 18.3346 6.07195 18.3346 10.0003C18.3346 13.9287 18.3346 15.8929 17.1142 17.1133C15.8939 18.3337 13.9297 18.3337 10.0013 18.3337C6.07293 18.3337 4.10875 18.3337 2.88836 17.1133C1.66797 15.8929 1.66797 13.9287 1.66797 10.0003Z",
    stroke: "#13B059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2689 7.56344C13.4642 7.7587 13.4642 8.07528 13.2689 8.27055L9.10225 12.4372C9.00848 12.531 8.88131 12.5837 8.7487 12.5837C8.61609 12.5837 8.48891 12.531 8.39514 12.4372L6.72848 10.7705C6.53322 10.5753 6.53322 10.2587 6.72848 10.0634C6.92374 9.86818 7.24032 9.86818 7.43558 10.0634L8.7487 11.3766L12.5618 7.56344C12.7571 7.36818 13.0737 7.36818 13.2689 7.56344Z",
    fill: "#13B059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.cbde01fced96f0b572543c697eed4676.svg";
export { ForwardRef as ReactComponent };